export default [
  {
    name: "20 drinks com Cachaça",
    type: "Apostila PDF",
    description:
      "Não há limites na hora de criar drinks com uma ótima cachaça. Seja qual for o ingrediente, a combinação com este destilado da cana de açúcar fica perfeito.",
    price: 21,
    image: "./img/cachaca.jpg",
  },
  {
    name: "20 drinks com Vodka",
    type: "Apostila PDF",
    description:
      "Bem equilibrada, a vodka, através da mixologia do bartender, destaca o ingrediente principal que esta sendo utilizado. Há drinks com vodka para todos os paladares, todos os bolsos e todos os níveis de intimidade com a coquetelaria.",
    price: 21,
    image: "./img/vodka.jpg",
  },
  {
    name: "20 drinks com Rum",
    type: "Apostila PDF",
    description:
      "De sabor refinado e aroma suave, o rum é produzido a partir do melaço de cana. Versátil, ele pode ser utilizado para compor sobremesas e drinks, sendo uma ótima opção para quem quer inovar na cozinha.",
    price: 21,
    image: "./img/rum.jpg",
  },
  {
    name: "20 drinks com Tequila",
    type: "Apostila PDF",
    description:
      "Primariamente na região da cidade de Tequila, México, e muito conhecida por shots, confira nesta apostila várias receitas para apreciar o sabor único desta bebida.",
    price: 21.0,
    image: "./img/tequila.jpg",
  },
  {
    name: "20 drinks com Café",
    type: "Apostila PDF",
    description:
      "O café brasileiro esta presente pelo mundo todo, confira aqui uma seleção de receitas com café que vão te deixar com água na boca.",
    price: 21.0,
    image: "./img/cafe.jpg",
  },
  {
    name: "20 drinks com Gin",
    type: "Apostila PDF",
    description:
      "O gin é um dos destilados mais consumidos no mundo, não só por seu sabor, mas por todas as possibilidades de combinações com frutas, especiarias, licores e outras bebidas.",
    price: 21.0,
    image: "./img/gin.jpg",
  },
  {
    name: "20 drinks com Whiskey",
    type: "Apostila PDF",
    description:
      "De sabor marcante, o whiskey/uísque/whisk é destilada de grãos, muitas vezes incluindo malte, que foi envelhecida em barris. No geral vemos ele ser apreciado puro, mas também pode ser utilizado para compor sobremesas e drinks.",
    price: 21.0,
    image: "./img/whiskey.jpg",
  },
  {
    name: "20 drinks com Sakê",
    type: "Apostila PDF",
    description:
      "Muitas possibilidades, sabores e experiências, uma bebida leve e com sabor marcante, que possibilita ousar novas experiências e experimentar novos sabores. Da apreciação do sake puro, até sofisticados e deliciosos drinks. Conheça mais sobre esse assunto e se torne também um expert em drinks com Sakê.",
    price: 21.0,
    image: "./img/sake.jpg",
  },
];
